(() => {
  const applyHeartbeatSlothMedia = () => {
    const config = document.querySelector('[data-pc-heartbeat-sloth-media]');
    if (!config) return;

    const replaceImage = (image, source) => {
      if (!image || !source || image.dataset.pcMediaOverride === source) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
      image.dataset.pcMediaOverride = source;
    };

    replaceImage(document.querySelector('[data-pc-gallery-slide="0"] img'), config.dataset.galleryImage);
    replaceImage(document.querySelector('[data-pc-gallery-thumb="0"] img'), config.dataset.galleryImage);
    replaceImage(
      document.querySelector('[data-petcottie-product-pdp] .pc-pdp__hero > img'),
      config.dataset.storyImage,
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeartbeatSlothMedia, { once: true });
  } else {
    applyHeartbeatSlothMedia();
  }

  document.addEventListener('shopify:section:load', applyHeartbeatSlothMedia);
})();
